const styles = theme => ({
  form: {
    display: "flex",
    flexDirection: "column"
  },
  registerTitle: {
    color: theme.palette.primary.default
  },
  registerExplanation: {
    color: theme.palette.primary.default
  },
  mobilLabel: {
    color: theme.palette.primary.default
  },
  labelTextColor: {
    color: theme.palette.primary.default
  },
  MuiInputBase: {
    input: {
      color: theme.palette.primary.default
    }
  },
  termsText: {
    color: theme.palette.primary.default,
    textDecoration: "none",
    marginRight: theme.spacing(2),
    marginLeft: theme.spacing(2)
  },
  termsContainer: {
    marginTop: theme.spacing(2)
  },
  termsLinks: {
    color: theme.palette.primary.light,
    cursor: "pointer",
    marginRight: theme.spacing(1),
    textDecoration: "none",
    whiteSpace: "nowrap"
  },
  AgreeAndText: {
    marginRight: theme.spacing(1),
    whiteSpace: "nowrap",
    color: theme.palette.primary.default
  },
  separator: {
    height: "10px"
  },
  checkBox: {
    padding: [0, "!important"],
    marginRight: theme.spacing(1)
  },
  termsAndConditionsText: {
    color: theme.palette.primary.default
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/pages/Register/components/RegisterForm/styles.js